import { useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthProvider';
import { RestApi } from '../../../services/rest-api';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { IField } from '../../../interfaces/field.interface';
import { useUtility } from '../../../contexts/UtilityContext';
import { ItemModel } from '../../../model/item.model';
import { Master } from '../../../model/masters.model';
import { Fields } from '../../../components/Fields';
import { YES_NO_OPTIONS } from '../../../constants/config';

interface IOwnProps {
  item?: ItemModel;
  groups: Array<Master>;
  types: Array<Master>;
  onSuccess: (item: ItemModel) => void;
}

export const ItemForm: React.FC<IOwnProps> = (props) => {
  const { authInfo } = useAuth();
  const { showLoader, hideLoader, toast } = useUtility();

  const fields: Array<IField> = [
    {
      label: "Item Name",
      required: true,
      props: {
        name: "item_name",
        type: "text",
        inputMode: "text",
        placeholder: "Item Name",
      }
    }, {
      label: "Type",
      required: true,
      props: {
        name: "item_type",
        type: "select",
        placeholder: "Type"
      },
      options: props.types,
    }, {
      label: "Group",
      required: true,
      props: {
        name: "group",
        type: "typeahead",
        inputMode: "text",
        placeholder: "Group"
      },
      options: props.groups,
    }, {
      label: "Purchase Order Price",
      required: true,
      props: {
        name: "po_rate",
        type: "number",
        inputMode: "numeric",
        placeholder: "Purchase Order Price"
      },
    }, {
      label: "Purchase Price",
      required: true,
      props: {
        name: "pi_rate",
        type: "number",
        inputMode: "numeric",
        placeholder: "Purchase Price"
      },
    }, {
      label: "Sale Order Price",
      required: true,
      props: {
        name: "so_rate",
        type: "number",
        inputMode: "numeric",
        placeholder: "Sale Order Price"
      },
    }, {
      label: "Sale Price",
      required: true,
      props: {
        name: "si_rate",
        type: "number",
        inputMode: "numeric",
        placeholder: "Sale Price"
      },
    }, {
      label: "Publish",
      required: true,
      props: {
        name: "publish",
        type: "select",
        placeholder: "Publish"
      },
      options: YES_NO_OPTIONS,
    }
  ];

  const { register, control, handleSubmit, reset } = useForm<ItemModel>({
    defaultValues: {},
    mode: "onTouched",
    reValidateMode: "onChange"
  });

  useEffect(() => {
    async function fetchData() {
      try {

        if (props.item) {
          showLoader();
          reset({
            ...props.item,
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        hideLoader();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.item, reset]);

  const onSubmit = handleSubmit(async (inputs) => {
    try {
      showLoader();
      const res = await RestApi<ItemModel>('post', props.item?.id ? 'updateItem' : 'createItem', {
        ...inputs,
        ...(props ? { id: props.item?.id } : {}),
        group_id: inputs.group?.id,
      }, authInfo.user.authorization);

      props.onSuccess(res);

    } catch (message) {
      toast(message, 'danger');
    } finally {
      hideLoader();
    }
  });

  return (
    <Form onSubmit={onSubmit} noValidate>
      <div>
        <Fields<ItemModel> fields={fields} control={control} register={register} />
      </div>
      <Button className='w-100 mt-3' variant='primary' type="submit">Submit</Button>
    </Form>
  );
};